import { hasNoLicense, LinkAppTypes, PlatformTypes, type App } from '../api/appsApi';

const { REACT_APP_CODEX_PLATFORM_TEMPLATE_URL } = process.env;

export type DigibookApp = App & {
  platformType: typeof PlatformTypes.P_INTERN;
  linkedApp?: {
    type: 'digibook';
  };
  platformLinkType: typeof LinkAppTypes.DIGIBOOK;
  platformUrl: never;
};

export type OldDigibookApp = App & {
  platformType: typeof PlatformTypes.P_INTERN;
  appType: {
    isDigibook: true;
  };
  platformLinkType: never;
  platformUrl?: string;
};

export function isDigibookApp(app: App): app is DigibookApp {
  return Boolean(app.platformType === PlatformTypes.P_INTERN && app.platformLinkType === LinkAppTypes.DIGIBOOK);
}

export function isOldDigibookApp(app: App): app is OldDigibookApp {
  return Boolean(app.platformType === PlatformTypes.WEB_EXTERN && app.appType.isDigibook);
}

export const getDisabledTooltip = (digibookApp: App): string | undefined => {
  if (hasNoLicense(digibookApp)) {
    if (digibookApp.state === 'preview') return 'PAGES.TOC_LEVEL.APPS.DIGIBOOK.PREVIEW_TOOLTIP';
    return 'PAGES.TOC_LEVEL.APPS.DIGIBOOK.NO_LICENSE_TOOLTIP';
  }
};

interface BuildCodexUrlParams {
  digibookId: string;
  moduleId: string;
  accountProvider?: string;
  page?: number;
}

export const buildCodexUrl = ({ digibookId, moduleId, accountProvider, page }: BuildCodexUrlParams) => {
  const provider = accountProvider || 'pelckmans';

  const url = REACT_APP_CODEX_PLATFORM_TEMPLATE_URL.replace(':provider', provider)
    .replace(':id', digibookId)
    .concat(page ? `/${page}` : '');

  const q = new URLSearchParams({
    superModuleId: moduleId,
  });

  return `${url}?${q}`;
};
